(function () {
  const SALE_PRICE_SELECTOR = '.price-sale .price-item-sale';
  const COMPARE_PRICE_SELECTOR = '.price-sale .price-item-regular';

  const observedPrices = new WeakSet();

  function moneyToCents(text) {
    const cleaned = String(text)
      .replace(/[^0-9.,-]/g, '')
      .replace(/,/g, '');

    const value = parseFloat(cleaned);

    return Number.isFinite(value)
      ? Math.round(value * 100)
      : null;
  }

  function formatMoney(cents) {
    const currency =
      window.Shopify?.currency?.active || 'USD';

    const locale =
      document.documentElement.lang || 'en-US';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function findDiscountBadge(priceBlock) {
    const candidates =
      priceBlock.querySelectorAll('span, div, small');

    return Array.from(candidates).find((element) => {
      const text = element.textContent.trim();

      return /^-\s*\d+(?:\.\d+)?%$/.test(text);
    });
  }

  function updateDiscountBadge(
    priceBlock,
    salePriceCents,
    comparePriceCents
  ) {
    const badge = findDiscountBadge(priceBlock);

    if (!badge) return;

    if (
      comparePriceCents <= 0 ||
      salePriceCents >= comparePriceCents
    ) {
      return;
    }

    const discountPercent = Math.round(
      ((comparePriceCents - salePriceCents) /
        comparePriceCents) *
        100
    );

    badge.textContent = `-${discountPercent}%`;
  }

  function watchPrice(salePrice) {
    if (observedPrices.has(salePrice)) return;

    const priceBlock = salePrice.closest('.price-sale');

    if (!priceBlock) return;

    const comparePrice =
      priceBlock.querySelector(COMPARE_PRICE_SELECTOR);

    if (!comparePrice) return;

    const baseSalePrice =
      moneyToCents(salePrice.textContent);

    const baseComparePrice =
      moneyToCents(comparePrice.textContent);

    if (
      baseSalePrice === null ||
      baseComparePrice === null
    ) {
      return;
    }

    function updatePrices() {
      const currentSalePrice =
        moneyToCents(salePrice.textContent);

      if (currentSalePrice === null) return;

      const optionIncrease =
        currentSalePrice - baseSalePrice;

      const newComparePrice =
        baseComparePrice + optionIncrease;

      comparePrice.textContent =
        formatMoney(newComparePrice);

      updateDiscountBadge(
        priceBlock,
        currentSalePrice,
        newComparePrice
      );
    }

    const observer = new MutationObserver(updatePrices);

    observer.observe(salePrice, {
      childList: true,
      characterData: true,
      subtree: true
    });

    observedPrices.add(salePrice);
  }

  function initializePriceSync() {
    document
      .querySelectorAll(SALE_PRICE_SELECTOR)
      .forEach(watchPrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePriceSync
    );
  } else {
    initializePriceSync();
  }

  const pageObserver =
    new MutationObserver(initializePriceSync);

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* Open Shopify live chat from any link ending in #chat */
document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href$="#chat"]');

  if (!link) return;

  event.preventDefault();

  const chat = document.querySelector('shopify-chat');

  if (!chat || !chat.shadowRoot) {
    console.warn('Shopify chat element not found.');
    return;
  }

  const activator = chat.shadowRoot.querySelector(
    'button[part="activator"]'
  );

  if (!activator) {
    console.warn('Shopify chat activator button not found.');
    return;
  }

  /* Only click if chat is currently closed */
  if (activator.getAttribute('aria-expanded') !== 'true') {
    activator.click();
  }
});